<template>
	<v-container fluid class="pa-0">
		<!-- normal toolbar -->
		<v-row class="grid-toolbar d-none d-sm-flex" no-gutters>
			<v-col class="flex-grow-0 flex-shrink-0">
				<v-menu
					content-class="grid-toolbar-menu"
					:close-on-content-click="false"
					offset-y
				>
					<template #activator="{ on, attrs, value }">
						<v-btn
							v-bind="attrs"
							v-on="on"
							class="settings-menu-btn"
							color="primary"
						>
							<v-icon>mdi-cog</v-icon>
							<v-icon v-if="value">mdi-menu-up</v-icon>
							<v-icon v-else>mdi-menu-down</v-icon>
						</v-btn>
					</template>
					<v-list>
						<template v-for="(item, i) in menuItems">
							<export-modal
								v-if="item.isExportModal"
								:key="`export-modal-${i}`"
								:timezone-options="true"
								:execution-options="false"
								:data-scope-options="true"
								@exportModalEvent="onExportModalEvent"
							>
								<template #activator="{ on, attrs }">
									<v-list-item v-bind="attrs" v-on="on">
										<v-list-item-content>
											<v-list-item-title
												>Export</v-list-item-title
											>
										</v-list-item-content>
									</v-list-item>
								</template>
							</export-modal>
							<item-group
								v-else-if="item.children"
								:key="`grid-group-${i}`"
								:item="item"
							/>
							<list-item
								v-else
								:key="`grid-item-${i}`"
								:item="item"
							/>
						</template>
					</v-list>
				</v-menu>
			</v-col>
			<v-col cols="2" class="flex-grow-0 flex-shrink-0 d-flex">
				<div class="view-title">
					{{ gridViewName }}
				</div>
			</v-col>
			<v-col class="flex-grow-1 flex-shrink-1">
				<quick-filter
					:Columns="visibleColumns"
					:filter="quickFilter"
					@filterChanged="onQuickFilterChanged"
				/>
			</v-col>
			<v-col class="flex-grow-0 flex-shrink-0 d-none d-lg-flex">
				<v-badge
					:value="advancedFilter.FiltersCount > 0"
					left
					bordered
					overlap
				>
					<template v-slot:badge>
						<span style="color: white">{{
							advancedFilter.FiltersCount
						}}</span>
					</template>
					<v-btn color="primary" @click="onShowAdvancedFilter">
						<v-icon class="mr-1">mdi-magnify</v-icon>
						Advanced search
					</v-btn>
				</v-badge>
			</v-col>
			<v-col class="flex-grow-0 flex-shrink-0 d-none d-lg-flex ml-2">
				<!-- Desktop Export Modal (≥lg) -->
				<export-modal
					:timezone-options="true"
					:execution-options="false"
					:data-scope-options="true"
					@exportModalEvent="onExportModalEvent"
				>
					<template #activator="{ on, attrs }">
						<v-btn v-bind="attrs" v-on="on" color="primary">
							<v-icon class="mr-1">mdi-cloud-download</v-icon>
							Export
						</v-btn>
					</template>
				</export-modal>
			</v-col>
			<v-col class="flex-grow-0 flex-shrink-0 d-none d-lg-flex ml-2">
				<v-btn color="primary" @click="onCreateNew">
					<v-icon class="mr-1">mdi-plus</v-icon> Create New
				</v-btn>
			</v-col>
			<v-col class="flex-grow-0 flex-shrink-0 d-lg-none">
				<!-- Medium Desktop Dots Menu (sm to lg) - Only visible between sm and lg -->
				<v-menu
					v-model="dotsMenuOpen"
					offset-y
					:close-on-content-click="false"
				>
					<template v-slot:activator="{ on, attrs }">
						<v-btn
							v-bind="attrs"
							v-on="on"
							class="d-lg-none"
							color="primary"
						>
							<v-icon>mdi-dots-vertical</v-icon>
						</v-btn>
					</template>
					<v-list class="d-lg-none">
						<v-list-item @click="onAdvancedSearchFromDots">
							<v-list-item-content>
								<v-list-item-title>
									<v-icon small left>mdi-magnify</v-icon>
									Advanced search
								</v-list-item-title>
							</v-list-item-content>
						</v-list-item>
						<export-modal
							:timezone-options="true"
							:execution-options="false"
							:data-scope-options="true"
							@exportModalEvent="onExportModalEventFromDots"
						>
							<template #activator="{ on, attrs }">
								<v-list-item v-bind="attrs" v-on="on">
									<v-list-item-content>
										<v-list-item-title>
											<v-icon small left
												>mdi-cloud-download</v-icon
											>
											Export
										</v-list-item-title>
									</v-list-item-content>
								</v-list-item>
							</template>
						</export-modal>
						<v-list-item @click="onCreateNew">
							<v-list-item-content>
								<v-list-item-title>
									<v-icon small left>mdi-plus</v-icon>
									Create New
								</v-list-item-title>
							</v-list-item-content>
						</v-list-item>
					</v-list>
				</v-menu>
			</v-col>
		</v-row>

		<!-- responsive toolbar -->
		<v-row class="grid-toolbar d-sm-none" no-gutters>
			<v-col class="flex-grow-0 flex-shrink-0">
				<v-menu
					content-class="grid-toolbar-menu"
					:close-on-content-click="false"
					offset-y
				>
					<template #activator="{ on, attrs, value }">
						<v-btn
							v-bind="attrs"
							v-on="on"
							class="settings-menu-btn"
							color="primary"
						>
							<v-icon>mdi-cog</v-icon>
							<v-icon v-if="value">mdi-menu-up</v-icon>
							<v-icon v-else>mdi-menu-down</v-icon>
						</v-btn>
					</template>
					<v-list>
						<template v-for="(item, i) in menuItems">
							<export-modal
								v-if="item.isExportModal"
								:key="`export-modal-${i}`"
								:timezone-options="true"
								:execution-options="false"
								:data-scope-options="true"
								@exportModalEvent="onExportModalEvent"
							>
								<template #activator="{ on, attrs }">
									<v-list-item v-bind="attrs" v-on="on">
										<v-list-item-content>
											<v-list-item-title
												>Export</v-list-item-title
											>
										</v-list-item-content>
									</v-list-item>
								</template>
							</export-modal>
							<item-group
								v-else-if="item.children"
								:key="`grid-group-${i}`"
								:item="item"
							/>
							<list-item
								v-else
								:key="`grid-item-${i}`"
								:item="item"
							/>
						</template>
					</v-list>
				</v-menu>
			</v-col>
			<v-col class="flex-grow-1 flex-shrink-1 view-title">
				{{ gridViewName }}
			</v-col>
		</v-row>
		<v-row class="grid-toolbar d-sm-none" no-gutters>
			<v-col class="flex-grow-1 flex-shrink-0">
				<quick-filter
					:Columns="visibleColumns"
					:filter="quickFilter"
					@filterChanged="onQuickFilterChanged"
				/>
			</v-col>
		</v-row>

		<manage-fields-dialog
			v-if="manageFieldsDialog"
			:showDialog="manageFieldsDialog"
			:hiddenColumns="hiddenColumns"
			:visibleColumns="visibleColumns"
			@close="onManageFieldsDialogClosed"
			@save="onManageFieldsDialogUpdate"
		/>
		<save-view-dialog
			v-if="saveViewDialog"
			:saveViewStoreAction="saveViewAction"
			:showDialog="saveViewDialog"
			:globalViewPermission="globalViewPermission"
			@close="onSaveViewDialogClose"
		/>
		<manage-views-dialog
			v-if="manageViewsDialog"
			:showDialog="manageViewsDialog"
			:viewsList="userGridViews"
			:deleteViewAction="deleteViewAction"
			:setDefaultViewAction="setDefaultViewAction"
			:setGlobalViewAction="setGlobalViewAction"
			:globalViewPermission="globalViewPermission"
			@close="onManageViewsClose"
		/>
		<filters-dialog
			v-if="showAdvancedFilter"
			:dialog="showAdvancedFilter"
			:filter="advancedFilter"
			:columns="visibleColumns"
			@filterChanged="onAdvancedFilterChanged"
		/>
	</v-container>
</template>
<script>
import QuickFilter from '../../shared/gridViews/QuickFilter.vue';
import FiltersDialog from '../../shared/gridViews/FiltersDialog';
import ManageFieldsDialog from '../../shared/gridViews/ManageFieldsDialog.vue';
import SaveViewDialog from '../../shared/gridViews/SaveViewDialog.vue';
import ManageViewsDialog from '../../shared/gridViews/ManageViewsDialog.vue';
import ExportModal from '../../shared/export/ExportModal.vue';
import permissionsMixin from '../../../mixins/permissionsMixin';
import gridViewOwnerMixin from '../../../mixins/grids/gridViewOwnerMixin';
import { Permissions } from '../../../enums/permissionsEnum';

import ItemGroup from '@/components/base/ItemGroup';
import ListItem from '@/components/base/ListItem';

import {
	InventoryFormGridActions,
	InventoryFormFormActions,
} from '../../../store/actions';
import { mapGetters } from 'vuex';
import {
	InventoryFormGridGetters,
	AuthGetterTypes,
} from '../../../store/getters';

export default {
	name: 'InventoryToolbar',
	mixins: [permissionsMixin, gridViewOwnerMixin],
	props: {
		gridViewName: String,
		quickFilter: Object,
		advancedFilter: Object,
		visibleColumns: Array,
		hiddenColumns: Array,
	},
	components: {
		QuickFilter,
		FiltersDialog,
		ManageFieldsDialog,
		SaveViewDialog,
		ManageViewsDialog,
		ExportModal,
		ListItem,
		ItemGroup,
	},
	data() {
		return {
			saveViewDialog: false,
			manageViewsDialog: false,
			manageFieldsDialog: false,
			saveViewAction: InventoryFormGridActions.SAVE_GRID_VIEW,
			deleteViewAction: InventoryFormGridActions.DELETE_GRID_VIEW,
			setDefaultViewAction:
				InventoryFormGridActions.SET_DEFAULT_GRID_VIEW,
			setGlobalViewAction:
				InventoryFormGridActions.SET_GLOBAL_GRID_VIEW,
			globalViewPermission: Permissions.Inventory.CreateGlobalGridView,
			showAdvancedFilter: false,
			multipleSelectionToggle: false,
			dotsMenuOpen: false,
		};
	},
	computed: {
		canBulkEditInventory() {
			return this.hasPermissions([Permissions.Inventory.BulkEdit]);
		},
		menuItems() {
			let items = [];
			if (
				this.viewsList &&
				this.viewsList.length > 0 &&
				//a global view belongs to whoever created it, the others cannot reshape it
				this.isViewOwner(this.gridView)
			) {
				items.push({
					title: 'Manage fields',
					clickHandler: () => this.manageFields(),
				});
			}
			items.push({
				title: 'Save this view',
				clickHandler: () => this.saveView(),
			});
			if (this.viewsList && this.viewsList.length > 0) {
				items.push({
					title: 'Manage views',
					clickHandler: () => this.manageViews(),
				});
				items.push({ title: 'Views', children: this.viewsList });
			}

			// Add Advanced Search for mobile (<sm)
			items.push({
				title: 'Advanced search',
				clickHandler: () => this.openAdvancedSearch(),
			});

			// Add Create New for mobile (<sm)
			items.push({
				title: 'Create new',
				clickHandler: () => this.onCreateNew(),
			});

			if (!this.canBulkEditInventory) {
				items.splice(
					items.indexOf((i) => i.title == 'Multiple Selection'),
					0
				);
			} else {
				items.unshift({
					title: 'Multiple Selection',
					clickHandler: () => this.onMultipleSelectionClick(),
				});
			}

			if (!this.multipleSelectionToggle) {
				items.splice(
					items.indexOf((i) => i.title == 'Bulk Edit'),
					0
				);
			} else {
				items.unshift({
					title: 'Bulk Edit',
					clickHandler: () => this.onBulkEdit(),
				});
			}
			return items;
		},
		...mapGetters({
			gridView: [InventoryFormGridGetters.GRID_VIEW],
			userGridViews: [InventoryFormGridGetters.USER_GRIDS_VIEWS],
			currentUserId: [AuthGetterTypes.CURRENT_USER_ID],
		}),
		viewsList() {
			return this.userGridViews.map((view) => {
				return {
					...view,
					title: view.Name,
					clickHandler: () => this.openView(view),
				};
			});
		},
	},
	methods: {
		onExportModalEvent(exportConfig) {
			const isDirectMode = !exportConfig.isBackgroundExport;
			const timeZone =
				exportConfig.timezone === 'utc'
					? 0
					: new Date().getTimezoneOffset() * -1;

			if (exportConfig.allData) {
				this.$store.dispatch(InventoryFormGridActions.EXPORT_ALL_DATA, {
					timeZone,
					isDirectMode,
				});
			} else {
				this.$store.dispatch(
					InventoryFormGridActions.EXPORT_CURRENT_PAGE,
					{ timeZone, isDirectMode }
				);
			}
		},
		onAdvancedSearchFromDots() {
			this.dotsMenuOpen = false;
			this.showAdvancedFilter = true;
		},
		onExportModalEventFromDots(exportConfig) {
			this.dotsMenuOpen = false;
			this.onExportModalEvent(exportConfig);
		},
		openAdvancedSearch() {
			this.showAdvancedFilter = true;
		},
		saveView() {
			this.saveViewDialog = true;
		},
		onSaveViewDialogClose() {
			this.saveViewDialog = false;
		},
		onShowAdvancedFilter() {
			this.showAdvancedFilter = true;
		},
		manageViews() {
			this.manageViewsDialog = true;
		},
		onManageViewsClose() {
			this.manageViewsDialog = false;
		},
		manageFields() {
			this.manageFieldsDialog = true;
		},
		onManageFieldsDialogClosed() {
			this.manageFieldsDialog = false;
		},
		onManageFieldsDialogUpdate(value) {
			this.$store
				.dispatch(
					InventoryFormGridActions.UPDATE_GRID_VIEW_FIELDS,
					value
				)
				.then((success) => {
					if (!success) return;
					this.manageFieldsDialog = false;
				});
		},

		openView(view) {
			this.$store.dispatch(InventoryFormGridActions.LOAD_GRID_VIEW, view);
		},
		onQuickFilterChanged(value) {
			this.$emit('quickFilterChanged', value);
		},
		onAdvancedFilterChanged(value) {
			this.$emit('advancedFilterChanged', value);
			this.showAdvancedFilter = false;
		},
		onCreateNew() {
			this.$store
				.dispatch(InventoryFormFormActions.LOAD_RECORD, {
					record: {},
					userId: this.currentUserId,
				})
				.then(() => {
					this.$router.push({ name: 'InventoryForm' });
				});
		},
		onMultipleSelectionClick() {
			this.multipleSelectionToggle = !this.multipleSelectionToggle;
			this.$emit('multipleSelectionClick', this.multipleSelectionToggle);
		},
		onBulkEdit() {
			this.$emit('bulkEdit');
		},
	},
};
</script>

<style lang="scss">
.grid-toolbar-menu .v-list-group {
	border-top: 1px solid #eee;
	border-bottom: 1px solid #eee;

	.v-list-item__title {
		font-size: 14px;
	}
}
</style>
